import { useState } from "react";
import { NavLink } from "react-router-dom";
import "./MobileNav.css";
import { IoMdSearch } from "react-icons/io";
import Search from "../../Config/MobileSearch/Search";
import cri1 from '../../../public/cri1.svg'
import cri2 from '../../../public/cri2.svg'
import cri3 from '../../../public/cri3.svg'
import cri5 from '../../../public/cri5.svg'
import horse from '../../../public/horse.png'
import gry from '../../../public/gry.png'
import casino from '../../../public/casino.svg'


import wireless from '../../../public/wireless.svg'
import { useSelector } from "react-redux";
import { newSky } from "../../../../AsianExchangeSrc/utils/helper/commonSelectors";

const MobileMenu = () => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
    const SkyDesign = useSelector(newSky());    

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const closeSearch = () => {
    setIsSearchOpen(false);
  };

  const { matches: cricketMatches } = useSelector((state) => state.matches.cricket);
  const { matches: soccerMatches } = useSelector((state) => state.matches.soccer);
  const { matches: tennisMatches } = useSelector((state) => state.matches.tennis);
  
  const filterInplayMatches = (matches) => {
    return matches?.data?.filter((e) => e?.matchOdds?.some((odds) => odds?.inplay));
  };
  
  const filteredCricketMatches = filterInplayMatches(cricketMatches);
  const filteredSoccerMatches = filterInplayMatches(soccerMatches);
  const filteredTennisMatches = filterInplayMatches(tennisMatches);

  return (
    <>
      <div className="mobile-menu">
        <ul>
          <li>
            <NavLink to="/cricket">
              <img src={cri1} alt="Cricket Icon" style={{ width:23, height:23 }} /> Cricket
              <div className="badge">
                <strong className="bach-box">
                  <img src={wireless} alt="Badge Icon" />
                </strong>
                <span className="badge-text">{filteredCricketMatches?.length || 0}</span>
              </div>
            </NavLink>
          </li>
          <li>
            <NavLink to="/soccer">
              <img src={cri2} alt="Soccer Icon" style={{ width:23, height:23 }} /> {SkyDesign === "true" ? "Football" : "Soccer"}
              <div className="badge">
                <strong className="bach-box">
                  <img src={wireless} alt="Badge Icon" />
                </strong>
                <span className="badge-text">{filteredSoccerMatches?.length || 0}</span>
              </div>
            </NavLink>
          </li>
          <li>
            <NavLink to="/tennis">
              <img src={cri3} alt="Tennis Icon" style={{ width:23, height:23 }} /> Tennis
              <div className="badge">
                <strong className="bach-box">
                  <img src={wireless} alt="Badge Icon" />
                </strong>
                <span className="badge-text">{filteredTennisMatches?.length || 0}</span>
              </div>
            </NavLink>
          </li>

          <li className="">
            <NavLink to="/horse">
              <img src={horse} alt="Tennis Icon" style={{ width:23, height:23 }} /> <span style={{textWrap:"nowrap"}}>Horse Racing</span>
              <div className="badge">
                <strong className="bach-box">
                  <img src={wireless} alt="Badge Icon" />
                </strong>
                <span className="badge-text">{0}</span>
              </div>
            </NavLink>
          </li>

          <li className="">
            <NavLink to="/greyhound">
              <img src={gry} alt="Tennis Icon" style={{ width:23, height:23 }} /> <span style={{textWrap:"nowrap"}}>Greyhound Racing </span>
              <div className="badge">
                <strong className="bach-box">
                  <img src={wireless} alt="Badge Icon" />
                </strong>
                <span className="badge-text">{0}</span>
              </div>
            </NavLink>
          </li>
          
          {/* <li>
            <NavLink to="/kabaddi">
              <img src={cri5} alt="Kabaddi Icon" style={{ width:23, height:23 }} /> Kabaddi
              <div className="badge">
                <strong className="bach-box">
                  <img src={wireless} alt="Badge Icon" />
                </strong>
                <span className="badge-text">0</span>
              </div>
            </NavLink>
          </li> */}

            <li>
            <NavLink to="/casino-games/live-casino">
              <img src={casino} alt="Casino Icon" style={{ width:23, height:23 }} /> Casino
            </NavLink>
          </li>
        </ul>

        {/* Search Icon */}
        <div className="mobile-search" onClick={toggleSearch}>
          <IoMdSearch />
        </div>
      </div>

      {/* Render Search Component */}
      {isSearchOpen && <Search closeSearch={closeSearch} />}

      <div className="wrap-highlight_list">
        <h3>Highlights</h3>
      </div>
    </>
  );
};

export default MobileMenu;
